import { Link, useLocation } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

export const Layout = ({ children, showBack = true, accent = "#22C55E" }) => {
  const location = useLocation();
  const isHome = location.pathname === "/";

  return (
    <div className="App min-h-screen" data-testid="app-layout">
      <header
        data-testid="app-header"
        className="sticky top-0 z-50 border-b-4 border-[#1a1a1a] bg-[#f7f5f0]/95 backdrop-blur supports-[backdrop-filter]:bg-[#f7f5f0]/80"
      >
        <div className="max-w-6xl mx-auto px-5 sm:px-8 py-3 sm:py-4 flex items-center justify-between gap-3">
          <Link to="/" className="flex items-center gap-3 group" data-testid="logo-link">
            <div
              className="w-10 h-10 sm:w-11 sm:h-11 border-4 border-[#1a1a1a] rounded-xl flex items-center justify-center font-display font-black text-xl shadow-hard-sm group-hover:rotate-[-6deg] transition-transform shrink-0"
              style={{ background: accent }}
            >
              G
            </div>
            <div className="leading-none">
              <div className="font-display font-black text-lg sm:text-xl tracking-tight">Guango</div>
              <div className="font-mono text-[9px] sm:text-[10px] uppercase tracking-[0.2em] text-[#737373] mt-1">
                Herramientas Creativas
              </div>
            </div>
          </Link>

          <nav className="flex items-center gap-2 sm:gap-3">
            {!isHome && showBack && (
              <Link
                to="/"
                data-testid="back-to-hub"
                className="press hidden sm:inline-flex items-center gap-2 bg-white border-4 border-[#1a1a1a] rounded-xl px-4 py-2 font-mono text-xs uppercase tracking-wider font-bold shadow-hard-sm"
              >
                <ArrowLeft className="w-4 h-4" strokeWidth={3} /> hub
              </Link>
            )}
            <a
              href="https://guango.co"
              target="_blank"
              rel="noreferrer"
              data-testid="guango-site-link"
              className="press inline-flex bg-[#1a1a1a] text-white border-4 border-[#1a1a1a] rounded-xl px-3 sm:px-4 py-2 font-mono text-[10px] sm:text-xs uppercase tracking-wider font-bold shadow-hard-sm"
            >
              guango.co ↗
            </a>
          </nav>
        </div>
      </header>

      <main>{children}</main>

      <footer className="mt-24 border-t-4 border-[#1a1a1a]">
        <div className="max-w-6xl mx-auto px-5 sm:px-8 py-8 flex flex-wrap items-center justify-between gap-3">
          <div className="font-mono text-xs uppercase tracking-[0.2em] text-[#4a4a4a]">
            Hecho con ☕ y código por <a href="https://guango.co" className="font-bold underline decoration-[#22c55e] decoration-4 underline-offset-4">guango</a>
          </div>
          <div className="font-mono text-xs uppercase tracking-[0.2em] text-[#737373]">
            <Link to="/admin" data-testid="footer-admin-link" className="hover:text-[#1a1a1a]">admin</Link>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default Layout;
